import { actionTypes } from '../actions/data';

// DEFAULT STATE
export const initData = {
  "fundData": [],
  "sortColumn": "mstarRatOverall",
  "sortDirection": "DESC",
  "levelData": "overall"
};

// WRITES
const data = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.LOAD_FUND_DATA:
      var filteredArray = action.value;
      var retained = [3, 4, 5];
      for (var i = filteredArray.length - 1; i >= 0; i--) {
        var obj = filteredArray[i];
        if (retained.indexOf(obj.mstarRatOverall) === -1) {
          filteredArray.splice(i, 1);
        }
      }

      return Object.assign({}, state, {
        fundData: filteredArray,
        sortColumn: "mstarRatOverall",
        sortDirection: "ASC",
        levelData: "overall"
      });
    case actionTypes.SET_SORT:
      let column = action.column;
      let direction = "ASC";
      if (column === state.sortColumn) {
        direction = state.sortDirection === "ASC" ? "DESC" : "ASC";
      }
      return Object.assign({}, state, {
        sortColumn: column,
        sortDirection: direction
      });
    case actionTypes.SET_LEVEL:
      let level = action.value;
      return Object.assign({}, state, {
        levelData: level,
      });
    default:
      return state
  }
}

// READS
export const getFundData = state => state.data.fundData;
export const getSortColumn = state => state.data.sortColumn;
export const getSortDirection = state => state.data.sortDirection;
export const getLevelData = state => state.data.levelData;

export default data;


// WEBPACK FOOTER //
// ./src/reducers/data.js